import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.product
 * @constructor
 */
export class ProductModel extends BaseModel {
  /**
   * @param {string} id
   * @param {string} sku
   * @param {string} title
   * @param {string} [subtitle]
   * @param {loavies.models.base.PriceModel} purchasePrice
   * @param {string[]} images
   * @param {string} [color]
   * @param {string} [productGroup]
   * @param {string} [size]
   * @param {string} parentSku
   * @param {string} [material]
   * @param {Date} purchaseDate
   * @param {Date} createdAt
   * @param {Date} updatedAt
   * @param {'sold'|'available'|'listed'|'draft'|'notInPossession'} status
   */
  constructor({
    id,
    sku,
    title,
    subtitle,
    purchasePrice,
    images,
    color,
    productGroup,
    size,
    parentSku,
    purchaseDate,
    createdAt,
    updatedAt,
    status,
    material,
  }) {
    super()

    /** @type {string} */
    this.id = id

    /** @type {string} */
    this.sku = sku

    /** @type {string} */
    this.title = title

    /** @type {null|string} */
    this.subtitle = subtitle

    /** @type {loavies.models.base.PriceModel} */
    this.purchasePrice = purchasePrice

    /** @type {string[]} */
    this.images = images

    /** @type {null|string} */
    this.color = color

    /** @type {null|string} */
    this.productGroup = productGroup

    /** @type {null|string} */
    this.size = size

    /** @type {string} */
    this.parentSku = parentSku

    /** @type {Date} */
    this.purchaseDate = purchaseDate

    /** @type {Date} */
    this.createdAt = createdAt

    /** @type {Date} */
    this.updatedAt = updatedAt

    /** @type {'sold'|'available'|'listed'|'draft'|'notInPossession'} */
    this.status = status

    /** @type {null|string} */
    this.material = material
  }
}

export const PRODUCT_STATUS = {
  AVAILABLE: 'available',
  LISTED: 'listed',
  SOLD: 'sold',
  DRAFT: 'draft',
  NOT_IN_POSSESSION: 'notInPossession',
}
